<div class="title-box p-3">
    <div class="title mx-auto" i18n="terms: page title">Terms & Conditions</div>
</div>
<section class="section-about">
    <div class="container">
        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">Terms and Conditions</h6>
            <p>Welcome to the Dhammika & Priscilla Perera Foundation ("DP Foundation," "we," "us," or "our"). By accessing or using our services, you agree to adhere to these Terms and Conditions ("Terms"). DP Foundation is committed to providing educational services through the DP Education website, a charitable digital education platform focused on enhancing human capabilities and alleviating poverty in Sri Lanka. Please read these Terms carefully.</p>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">1. Acceptance of Terms</h6>
            <p>By accessing or using our website, applications, or any products or services offered by DP Foundation ("Services"), you confirm that you have read, understood, and agree to these Terms. If you do not agree with any part of these Terms, please refrain from using our Services.</p>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">2. Our Services</h6>
            
            <ul>
                <li>
                    <b>Purpose:</b> DP Foundation provides educational content through the DP Education website, aimed at creating a free, secure, and ad-free learning environment.
                </li>
                <li>
                    <b>Eligibility:</b> Our Services are intended for users who can legally enter into binding contracts in their respective jurisdictions. Users under 18 must obtain consent from a legal guardian to use our Services.
                </li>
                <li>
                    <b>Content Access:</b> We have encouraged teachers and institutions to use content for teaching purposes. Our Services are for personal, non-personal, non-commercial use only. Users are prohibited from copying, redistributing, or reselling any content provided by DP Foundation.
                </li>
            </ul>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">3. Privacy Principles and Data Protection</h6>
            <h6>Children’s Privacy Notice</h6>
            <p>We prioritize the protection of children’s privacy. Our Services do not knowingly collect personal information from children under 13 without parental consent. Child-directed content is safeguarded from targeted advertising and tracking technologies.</p>
            
            <h6>Information Collection</h6>
            <p>We may collect personal information when you register, use our Services, or contact us. This information may include your username, email address, birthdate, usage patterns, device information, and location.</p>

            <h6>Use of Information</h6>
            <p>The information collected is used to enhance and personalize your experience, respond to inquiries, improve service features, and conduct educational research</p>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">4. Data Retention and Deletion Practices</h6>
            
            <ul>
                <li>
                    <b>Retention Guidelines:</b> Personal data is retained only as long as necessary for educational purposes or to meet legal requirements.
                </li>
                <li>
                    <b>Deletion Option:</b> Users can request the deletion of their data by following the specified steps. DP Foundation will securely delete or anonymize data once it is no longer needed.
                </li>
            </ul>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">5. User Conduct</h6>
            
            <p>Users agree not to engage in prohibited activities, including:</p>
            <ul>
                <li>
                    <b>Unauthorized Access:</b> Attempting to access unauthorized areas or accounts within our systems.
                </li>
                <li>
                    <b>Misuse of Services:</b> Using the Services for illegal, harmful, or disruptive purposes, or activities that could harm DP Foundation or its users.
                </li>
                <li>
                    <b>Content Sharing:</b> Posting inappropriate content, including offensive, defamatory, or infringing materials, in public areas or forums of DP Foundation.
                </li>
            </ul>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">6. International Data Transfers and Regional Privacy Rights</h6>
            
            <ul>
                <li>
                    <b>Regional Privacy Rights:</b> Users in specific regions may have rights to access, delete, correct, or object to data processing. DP Foundation respects these rights in compliance with regional laws.
                </li>
                <li>
                    <b>International Data Transfers:</b> DP Foundation processes international user data in accordance with Sri Lankan laws, which may differ from privacy protections in users’ home countries.
                </li>
            </ul>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">7. Security Measures</h6>
            
            <ul>
                <li>
                    <b>Encryption Standards:</b> DP Foundation employs encryption for data storage and transmission.
                </li>
                <li>
                    <b>User Education on Security:</b> We encourage users to protect their accounts by choosing secure usernames and passwords.
                </li>
            </ul>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">8. Intellectual Property</h6>
            
            <ul>
                <li>
                    <b>Ownership:</b> All content, materials, trademarks, and intellectual property are the exclusive property of DP Foundation or its licensors.
                </li>
                <li>
                    <b>Restrictions:</b> Users are prohibited from copying, modifying, distributing, or reverseengineering any content or materials without prior written consent.
                </li>
            </ul>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">9. Transparency and User Control</h6>
            
            <ul>
                <li>
                    <b>Account Management:</b> Users can access, correct, or delete personal information through account settings.
                </li>
                <li>
                    <b>Third-Party Service Opt-In:</b> Users can choose to link or unlink third-party services and opt out as desired.
                </li>
            </ul>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">10. Applicant Information</h6>
            
            <ul>
                <li>
                    <b>Applicant Data:</b>  If you apply for a position, we may collect, store, and process data for recruitment purposes in accordance with our privacy practices
                </li>
            </ul>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">11. Changes to Services and Content</h6>
            
            <p>DP Foundation reserves the right to modify, discontinue, or change any aspect of our Services, including content and features. Significant changes will be communicated in advance when possible</p>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">12. Third-Party Links and Content</h6>
            
            <p>Our Services may include links to third-party websites. DP Foundation does not endorse or assume responsibility for third-party content, products, or services. Users should review thirdparty policies before accessing or using linked content.</p>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">13. Disclaimer of Warranties</h6>
            
            <ul>
                <li>
                    <b>As-Is Basis:</b> Our Services are provided "as-is" without any warranties or guarantees regarding accuracy, completeness, or reliability.
                </li>
                <li>
                    <b>No Liability for User Decisions:</b> DP Foundation is not responsible for any decisions made based on our content. Users are encouraged to consult additional sources for educational or personal decisions.
                </li>
            </ul>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">14. Limitation of Liability</h6>
            
            <ul>
                <li>
                    <b>No Liability for Damages:</b> To the fullest extent permitted by law, DP Foundation and its affiliates are not liable for any indirect or consequential damages arising from your use of the Services.
                </li>
            </ul>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">15. User-Generated Content and Public Forums</h6>
            
            <ul>
                <li>
                    <b>Public Nature:</b> Content shared in public forums may be visible to all users.
                </li>
                <li>
                    <b>Monitoring and Removal:</b> DP Foundation reserves the right to monitor and remove content as necessary to maintain a respectful environment.
                </li>
            </ul>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">16. Modification of Terms</h6>
            
            <p>DP Foundation may amend these Terms at any time. Material changes will be communicated on our website, and continued use of the Services constitutes acceptance of the revised Terms.</p>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">17. Termination of Service</h6>
            
            <p>DP Foundation reserves the right to suspend, restrict, or terminate access for any user who violates these Terms or applicable law.</p>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">18. Governing Law and Jurisdiction</h6>
            
            <ul>
                <li>
                    <b>Applicable Law:</b> These Terms and any disputes arising from the Services will be governed by the laws of Sri Lanka.
                </li>
                <li>
                    <b>Dispute Resolution:</b> Disputes are subject to the jurisdiction of the courts in Sri Lanka.
                </li>
            </ul>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">19. Contact Us</h6>

            <p>For any questions or concerns regarding these Terms, please reach out to us at:</p>
            
            <ul>
                <li>
                    Email: <a href="mailto:info@dpedu.org">info@dpedu.org</a>
                </li>
                <li>
                    Mail: Dhammika & Priscilla Perera Foundation, 29th Floor, West Tower, World Trade Center, Colombo 01, Sri Lanka
                </li>
            </ul>
        </div>
    </div>
</section>
